import {createLocalizationContext} from "@variocube/app-ui";

export const {StorageLocalizationProvider, useLocalization} = createLocalizationContext<
	typeof import("./locales/en.json")
>({
	load: lang => import(`./locales/${lang}.json`),
	missing: location.hostname == "localhost" ? key => `??${key}??` : "fallback",
	fallback: "en",
});

export const SUPPORTED_LANGUAGES = [
	{language: "de", displayName: "Deutsch"},
	{language: "de-CH", displayName: "Deutsch (CH)"},
	{language: "en", displayName: "English"},
	{language: "it", displayName: "Italiano"},
	{language: "pl", displayName: "Polski"},
];
